import { resolveImageUrl } from '../../utils/url';

export default function EnterpriseLoginVisual({ appName, logoUrl, claim, fusszeile, productLogo = false }: {
  appName: string;
  logoUrl?: string | null;
  claim: string;
  fusszeile?: string;
  productLogo?: boolean;
}) {
  const customBrand = !!logoUrl || (appName !== 'NALVRA SERVICE' && appName !== 'AISupportDesk');
  return (
    <aside className={`asd-enterprise-visual${productLogo ? ' nalvra-product-login' : ''}`} aria-label={productLogo ? 'NALVRA SERVICE' : customBrand ? appName : 'NALVRA SERVICE'}>
      <div className="nalvra-login-visual">
        {customBrand && !productLogo ? (
          logoUrl ? <img src={resolveImageUrl(logoUrl)} alt={appName} className="nalvra-login-operator-logo" />
            : <p className="text-3xl font-bold">{appName}</p>
        ) : (
          <img src="/brand/nalvra-service-logo.png" alt="NALVRA SERVICE – Service Operations Platform" className="nalvra-service-art" />
        )}
        <p className="nalvra-login-caption">{claim}</p>
        {fusszeile && <p className="nalvra-login-version">{fusszeile}</p>}
      </div>
    </aside>
  );
}
